import {TimeLineMax} from 'gsap'

export class Home {
    constructor() {

        this.tlParallax = new TimelineMax({paused:true});
        this.inertia = 0;

        this.scrollOffset = 0
        this.test = document.querySelector('.montagne-left');

        //this.init();

    }

    init() {

        this.loop();
    }

    loop() {
        this.scrollOffset = window.pageYOffset || window.scrollTop;
        this.test.style.bottom = -this.scrollOffset  + "px";
        requestAnimationFrame(this.loop.bind(this));
    }

}
